export function slugToTitle(slug: string) {
  return slug.replace(/-/g, ' ').replace(/^./, c => c.toUpperCase());
}
